import { ApiService } from "@/api";

export const getGroupList = () => {
  return ApiService.baseAction("group/list", {}, "get");
};
